/**
 * API route constants — single source of truth for all endpoints.
 * Used by both backend (handlers) and frontend (API client).
 */
export const API_VERSION = 'v1';
export const API_BASE = `/api/${API_VERSION}`;
export const API_ROUTES = {
    // Auth (SSO-backed)
    AUTH_LOGIN: `${API_BASE}/auth/login`,
    AUTH_LOGOUT: `${API_BASE}/auth/logout`,
    AUTH_ME: `${API_BASE}/auth/me`,
    // Employees
    EMPLOYEES: `${API_BASE}/employees`,
    EMPLOYEE_BY_ID: `${API_BASE}/employees/:employeeId`,
    EMPLOYEE_REPORTS: `${API_BASE}/employees/:employeeId/reports`,
    EMPLOYEE_SCORES: `${API_BASE}/employees/:employeeId/scores`,
    EMPLOYEE_DEACTIVATE: `${API_BASE}/employees/:employeeId/deactivate`,
    EMPLOYEE_LINKS: `${API_BASE}/employees/:employeeId/links`,
    EMPLOYEE_LINK_BY_SERVICE: `${API_BASE}/employees/:employeeId/links/:service`,
    EMPLOYEES_BULK_MODE: `${API_BASE}/employees/bulk-mode`,
    EMPLOYEES_BATCH_RESOLVE: `${API_BASE}/employees/batch-resolve`,
    // Reports
    REPORTS: `${API_BASE}/reports`,
    REPORT_BY_ID: `${API_BASE}/reports/:reportId`,
    REPORTS_DAILY: `${API_BASE}/reports/daily/:date`,
    REPORTS_EXPORT: `${API_BASE}/reports/export`,
    // Verification
    VERIFICATIONS: `${API_BASE}/verifications`,
    VERIFICATION_BY_ID: `${API_BASE}/verifications/:verificationId`,
    REVERIFY: `${API_BASE}/verifications/reverify`,
    // Scores
    SCORES_WEEKLY: `${API_BASE}/scores/weekly`,
    SCORES_MONTHLY: `${API_BASE}/scores/monthly`,
    // Performance
    PERFORMANCE_REVIEW: `${API_BASE}/performance/review`,
    PERFORMANCE_SALARY: `${API_BASE}/performance/salary-recommendation`,
    // Flags
    FLAGS: `${API_BASE}/flags`,
    FLAGS_PENDING: `${API_BASE}/flags/pending`,
    // Settings
    SETTINGS: `${API_BASE}/settings`,
    // Collection
    COLLECTION_TRIGGER: `${API_BASE}/collection/trigger`,
    COLLECTION_EXECUTIONS: `${API_BASE}/collection/executions`,
    COLLECTION_EXECUTION_BY_ID: `${API_BASE}/collection/executions/:executionId`,
    // Health
    HEALTH: `${API_BASE}/health`,
};
export const DASHBOARD_ROUTES = {
    HOME: '/',
    LOGIN: '/login',
    DASHBOARD: '/dashboard',
    EMPLOYEES: '/employees',
    EMPLOYEE_DETAIL: '/employees/:employeeId',
    DAILY_VIEW: '/daily/:date',
    FLAGS: '/flags',
    PERFORMANCE: '/performance',
    REVERIFY: '/reverify',
    SETTINGS: '/settings',
    MY_REPORTS: '/my-reports',
    REPORTS: '/reports',
};
//# sourceMappingURL=routes.js.map